import { el } from '../utils/dom.js';

/*
 * dataTable({
 *   columns: [{ key, label, render?, className? }],
 *   rows: [...],
 *   empty: 'Mensaje cuando no hay filas',
 *   pagination: { page, pages, onPage }
 * })
 */
export function dataTable({ columns, rows, empty = 'Sin registros', pagination, emptyAction }) {
  const wrap = el('div', { class: 'table-wrap' });
  if (!rows || rows.length === 0) {
    const emptyEl = typeof empty === 'string'
      ? el('div', { class: 'empty' },
          el('div', { class: 'empty-icon' }, '✦'),
          el('h3', {}, empty),
          emptyAction || null,
        )
      : empty;
    wrap.appendChild(emptyEl);
    return wrap;
  }

  const table = el('table', { class: 'table' });
  const thead = el('thead', {},
    el('tr', {}, ...columns.map((c) => el('th', { class: c.className || '' }, c.label || c.key)))
  );
  const tbody = el('tbody', {}, ...rows.map((r) =>
    el('tr', {}, ...columns.map((c) => {
      const td = el('td', { class: c.className || '' });
      const v = c.render ? c.render(r) : r[c.key];
      if (v == null) td.textContent = '—';
      else if (typeof v === 'string' || typeof v === 'number') td.textContent = String(v);
      else td.appendChild(v);
      return td;
    }))
  ));
  table.appendChild(thead);
  table.appendChild(tbody);
  wrap.appendChild(table);

  if (pagination && pagination.pages > 1) {
    const { page, pages, onPage } = pagination;
    const prev = el('button', {
      class: 'btn',
      disabled: page <= 1,
      onclick: () => onPage(page - 1),
    }, '← Anterior');
    const next = el('button', {
      class: 'btn',
      disabled: page >= pages,
      onclick: () => onPage(page + 1),
    }, 'Siguiente →');
    wrap.appendChild(el('div', { class: 'pagination' },
      el('span', { class: 'muted text-sm' }, `Pagina ${page} de ${pages}`),
      prev, next,
    ));
  }
  return wrap;
}
